import {Vue} from "ui.vue";
import {MapMixin} from "./map-mixin";
import {Request} from "citrus.plugins.request";
import SlideUpDown from 'vue-slide-up-down';

import EnlargeableImage from '@diracleo/vue-enlargeable-image';
Vue.use(EnlargeableImage);

Vue.component('vue-slide-up-down', SlideUpDown);

export default {
	name: "CitrusComponentElementList",
	mixins: [
		MapMixin,
	],
	components: {EnlargeableImage},
	data: () => {
		return {
			loading: false,
			items: false,
			load: {
				start: false,
				pageNumber: 1,
				isMoreLink: false
			},
			ajaxParams: {
				parameters: "",
				rewrite: {},
				filter: {}
			},
			pagination: false,
			locPrefix: "CC_ELEMENT_LIST_",
			elementForScrollTo: "",
		};
	},
	created() {
		BX.addCustomEvent('CatalogSectionDefault:sort', this.onSort);
		BX.addCustomEvent('CatalogSectionDefault:filter', this.onFilter);
	},
	methods: {
		detailPageUrl(url) {
			return null === url || !url ? "javascript:void(0)" : url;
		},
		changePage(data) {
			this.load.pageNumber = data.hasOwnProperty("pageNumber") ? data["pageNumber"] : 1;
			this.load.isMoreLink = data.hasOwnProperty("isMoreLink") ? data["isMoreLink"] : false;

			this.refresh();
		},
		onSort(sort, order) {
			if (!this.ajaxParams.hasOwnProperty('rewrite')) {
				this.ajaxParams.rewrite = {};
			}

			this.ajaxParams.rewrite.ELEMENT_SORT_FIELD = sort;//catalog.section
			this.ajaxParams.rewrite.ELEMENT_SORT_ORDER = order;//catalog.section

			this.ajaxParams.rewrite.SORT_BY1 = sort;//news.list
			this.ajaxParams.rewrite.SORT_ORDER1 = order;//news.list

			this.load.pageNumber = 1;
			this.load.isMoreLink = false;

			this.refresh();
		},
		onFilter(filter, filterUrl = "", isReset = false) {
			if (!this.ajaxParams.hasOwnProperty('filter')) {
				this.ajaxParams.filter = {};
			}

			if (!isReset) {
				this.ajaxParams.filter = Object.assign({}, this.ajaxParams.filter, filter);
			}
			else {
				this.ajaxParams.filter = {};
			}

			this.load.pageNumber = 1;
			this.load.isMoreLink = false;

			this.refresh();
		},
		refresh() {
			if (this.loading || !this.pagination) {
				return;
			}

			this.loading = true;

			this.ajaxParams["nav"] = {
				param: this.pagination.pageParam,
				value: this.load.pageNumber
			};

			this.load.start = true;

			(new Request())
				.setModeModule()
				.setAction("citrus:component.component.execute")
				.setData(this.ajaxParams)
				.send()
				.then((response) => {
					this.loading = false;

					if (this.load.isMoreLink) {
						this.items = this.items.concat(response.items);
					} else {
						this.items = response.items;
						this.scrollToElement();
					}

					this.$set(this, "pagination", response.pagination);

					this.load.start = false;
					BX.onCustomEvent("Citrus.Component.Element.List:ajaxLoadDataCompleted", [response.items]);
				}, (error) => {
					console.error(error);
					this.load.start = false;
				});
		},
		async scrollToElement() {
			let slide = this.elementForScrollTo.length > 0 ? document.querySelector(this.elementForScrollTo) : this.$el;
			if (!slide) {
				return;
			}

			let top = window.scrollY + slide.getBoundingClientRect().y;
			window.scrollTo({
				top: top,
				behavior: 'smooth'
			});
		},
		show(item) {
			item.active = !item.active;
		},
		declension(value, words) {
			value = Math.abs(value) % 100;
			var num = value % 10;
			if (value > 10 && value < 20) return words[2];
			if (num > 1 && num < 5) return words[1];
			if (num == 1) return words[0];
			return words[2];
		},
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases(this.locPrefix);
		},
		countText() {
			let count = this.pagination ? this.pagination.recordCount : 0;
			if (count == 0) {
				return "";
			}

			return count + ' ' + this.declension(count, [
				this.loc[this.locPrefix + "_COUNT_1"],
				this.loc[this.locPrefix + "_COUNT_4"],
				this.loc[this.locPrefix + "_COUNT_5"]
			]);
		},
	}
};
